class ScrollLock {
  static lockCount = 0;
  static scrollY = 0;
  static paddingRight = '';

  static lock() {
    if (this.lockCount === 0) {
      this.scrollY = window.scrollY || window.pageYOffset;
      this.paddingRight = document.body.style.paddingRight;

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        const currentPadding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
      }

      document.documentElement.classList.add('scroll-locked');
      document.body.classList.add('scroll-locked');
      document.body.style.top = `-${this.scrollY}px`;
    }

    this.lockCount += 1;
  }

  static unlock() {
    if (this.lockCount <= 0) return;

    this.lockCount -= 1;

    if (this.lockCount !== 0) return;

    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    document.body.style.top = '';
    document.body.style.paddingRight = this.paddingRight;
    window.scrollTo(0, this.scrollY);
  }

  static reset() {
    if (this.lockCount === 0) return;

    this.lockCount = 0;
    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    document.body.style.top = '';
    document.body.style.paddingRight = this.paddingRight;
    window.scrollTo(0, this.scrollY);
  }
}

window.scrollLock = ScrollLock;
